var _Path, _Path2, _Path3, _Path4, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgTabInventoryActive = function SvgTabInventoryActive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.5,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 18 16.5"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#tab-inventory-active_svg__a)",
    stroke: "url(#tab-inventory-active_svg__b)",
    strokeLinejoin: "round",
    strokeWidth: 0.281,
    d: "m6.375 2.25-1.5.563-3.187 2.25q-.187.187 0 .562l1.125 2.25q.186.375.562.188l1.313-.75v6.937q0 .563.562.563h7.5q.563 0 .563-.563V7.313l1.312.75q.375.186.563-.188l1.124-2.25q.188-.375-.187-.562l-3-2.25-1.5-.563c-.375 2.25-4.875 2.25-5.25 0Z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#E4C89A",
    strokeLinecap: "round",
    strokeOpacity: 0.45,
    strokeWidth: 0.225,
    d: "M6.469 2.625c.843 2.063 4.219 2.063 5.062 0"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    stroke: "url(#tab-inventory-active_svg__c)",
    strokeLinecap: "round",
    strokeWidth: 0.319,
    d: "M4.969 7.688v6.468q0 .375.375.375h7.312"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#D0AD82",
    strokeLinecap: "round",
    strokeOpacity: 0.28,
    strokeWidth: 0.188,
    d: "M13.031 7.688v6.468q0 .375-.375.375"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "tab-inventory-active_svg__a",
    x1: 6.188,
    x2: 12,
    y1: 2.25,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FDF6A9"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#EBB764"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "tab-inventory-active_svg__b",
    x1: 9,
    x2: 9,
    y1: 2.063,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FFFBE6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.5,
    stopColor: "#FCF1C8"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#D9B483"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "tab-inventory-active_svg__c",
    x1: 5.625,
    x2: 13.313,
    y1: 3,
    y2: 13.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#fff",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgTabInventoryActive;